import { useContext, useState } from 'react';

import { UserContext } from '~/components/providers/UserProvider';

import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import { GroupEntryViewsProvider } from '~/domains/group/components/GroupEntryViewsProvider/GroupEntryViewsProvider';

import MyEntriesLayout from '../MyEntriesLayout';

import MyEntriesContent from './MyEntriesContent';
import useMyContestEntries from './useMyContestEntries';
import MyEntriesModal from './MyEntriesModal';

type MyEntriesTeamsProps = {
  fullContest: FullContest;
  myEntriesStatus?: string;
  openEntryNameEditModal: (entryInfo: { id: string; name: string }) => void;
};

const ITEMS_COUNT = 3;

function MyEntriesTeams({
  myEntriesStatus,
  fullContest,
  openEntryNameEditModal,
}: MyEntriesTeamsProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user } = useContext(UserContext);
  const { teamPicks, userEntries, defaultSlate } = useMyContestEntries({
    pageSize: ITEMS_COUNT,
    scheduleId: fullContest?.schedule_id,
  });

  const isLoading = userEntries.isLoading || defaultSlate.isLoading;
  const isError = teamPicks.isError || userEntries.isError || defaultSlate.isError;

  return (
    <MyEntriesLayout
      myEntriesStatus={myEntriesStatus}
      isLoading={isLoading}
      isError={isError}
      userEntries={userEntries?.data}
      handleAllViewClick={() => setIsModalOpen(true)}
      fullContest={fullContest}
    >
      {user?.id ? (
        <GroupEntryViewsProvider
          entryIds={userEntries?.data?.data?.map(({ id }) => id) ?? []}
          userId={user.id}
        >
          <MyEntriesContent
            fullContest={fullContest}
            entries={userEntries?.data?.data}
            teamPicks={teamPicks?.data}
            defaultSlate={defaultSlate?.slate}
            openEntryNameEditModal={openEntryNameEditModal}
          />
        </GroupEntryViewsProvider>
      ) : (
        <MyEntriesContent
          fullContest={fullContest}
          entries={userEntries?.data?.data}
          teamPicks={teamPicks?.data}
          defaultSlate={defaultSlate?.slate}
          openEntryNameEditModal={openEntryNameEditModal}
        />
      )}
      <MyEntriesModal
        myEntriesStatus={myEntriesStatus}
        isOpen={isModalOpen}
        fullContest={fullContest}
        onClose={() => setIsModalOpen(false)}
        initialTotal={userEntries?.data?.total}
        openEntryNameEditModal={openEntryNameEditModal}
      />
    </MyEntriesLayout>
  );
}

export default MyEntriesTeams;
